import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindorefService {
  constructor(@Inject(DOCUMENT) private currentDocument: any) {}

  getNativeWindow() {
    return window;
  }

  getNativeDocument(): any {
    return this.currentDocument;
  }

}
